const notPointer = window.matchMedia(
	'(pointer: none), (pointer: coarse), (hover: none)'
);

if (notPointer.matches) {
	document.querySelectorAll('.bs-paragraph abbr[title]').forEach((elem) => {
		elem.setAttribute('tabindex', '0');
	});
}
